import { useEffect, useState } from 'react';
import { DocumentType, useLazyDocumentsQuery } from '../../../graphql/graphql';

export default function useDocuments() {
	const [getDocumentsQuery, { data, isLoading }] = useLazyDocumentsQuery();
	const [page, setPage] = useState(1);

	const getDocuments = (
		userId: string,
		workplaceId: string,
		types: DocumentType[],
	) => {
		getDocumentsQuery({
			userId,
			workplaceId,
			types,
			skip: (page - 1) * 10,
		});
	};

	const getFlatDocuments = (filter: object) => {
		getDocumentsQuery({
			...filter,
			skip: (page - 1) * 10,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getDocuments,
		getFlatDocuments,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
